export default {
  data() {
    return {

      url:{
        list:SZH.assets.api + '/AuctionPurchase2/GetAuctionInfoByPaging',
        cuttent:SZH.assets.api + '/Custom/GetCurrentDateTime',
        GetListNews: SZH.assets.api + '/Market/GetListNews',
        WorkOrderSumbit: SZH.assets.api + '/Custom/WorkOrderSumbit',//提交工单
      },
      dialogFormVisible:false,
      fullscreenLoading:false,
      form:{
        F_Title:'',
        F_Content:'',
      }
    }

  },
  methods: {
    add(){
      this.form.F_Title = '';
      this.form.F_Content = '';
      this.dialogFormVisible = true;
    },
    submitWork(){
      let self = this;
      if(!self.form.F_Title){
        self.$message.error('请输入主题！');
        return
      }
      if(!self.form.F_Content){
        self.$message.error('请输入内容！');
        return
      }
      self.fullscreenLoading = true;
      self.$http.post(self.url.WorkOrderSumbit,self.form)
        .then(result => {
          if (result.state == true) {
            self.$message.success('提交成功');
            self.dialogFormVisible = false;
            self.fullscreenLoading = false;
          } else {
            self.fullscreenLoading = false;
            self.$message.error(result.message);
          }

        }, () => {
          self.fullscreenLoading = false;
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
        });
    },
  },
  destroyed(){

  },
  computed: {

  },
  components: {},
  mounted() {


  }
}



// WEBPACK FOOTER //
// ./src/views/IndexHome/IndexHome.js